if (!customElements.get('journal-share')) {
  customElements.define(
    'journal-share',
    class JournalShare extends HTMLElement {
      connectedCallback() {
        if (this.isInitialized) return;
        this.isInitialized = true;

        this.copyButton = this.querySelector('[data-journal-copy]');
        this.nativeButton = this.querySelector('[data-journal-native]');
        this.status = this.querySelector('[data-journal-share-status]');
        this.shareUrl = this.dataset.shareUrl || window.location.href;
        this.shareTitle = this.dataset.shareTitle || document.title;
        this.statusTimer = null;

        if (this.copyButton) {
          this.copyButton.hidden = false;
          this.copyButton.addEventListener('click', () => this.copyLink());
        }

        if (this.nativeButton && navigator.share) {
          this.nativeButton.hidden = false;
          this.nativeButton.addEventListener('click', () => this.openNativeShare());
        }
      }

      disconnectedCallback() {
        window.clearTimeout(this.statusTimer);
      }

      async openNativeShare() {
        try {
          await navigator.share({
            title: this.shareTitle,
            url: this.shareUrl,
          });
        } catch (error) {
          if (error.name !== 'AbortError') this.setStatus('Sharing is unavailable. Please copy the link instead.');
        }
      }

      async copyLink() {
        try {
          if (navigator.clipboard && window.isSecureContext) {
            try {
              await navigator.clipboard.writeText(this.shareUrl);
            } catch (error) {
              this.copyWithFallback();
            }
          } else {
            this.copyWithFallback();
          }

          this.copyButton.classList.add('is-copied');
          this.copyButton.setAttribute('aria-label', 'Link copied');
          this.setStatus('Link copied');
        } catch (error) {
          this.setStatus('The link could not be copied. Please copy it from the address bar.');
        }
      }

      copyWithFallback() {
        const temporaryInput = document.createElement('textarea');
        temporaryInput.value = this.shareUrl;
        temporaryInput.setAttribute('readonly', '');
        temporaryInput.style.position = 'fixed';
        temporaryInput.style.opacity = '0';
        document.body.appendChild(temporaryInput);
        temporaryInput.select();

        let copied = false;
        try {
          copied = document.execCommand('copy');
        } finally {
          temporaryInput.remove();
        }

        if (!copied) throw new Error('Copy command failed');
      }

      setStatus(message) {
        window.clearTimeout(this.statusTimer);
        this.status.textContent = message;

        this.statusTimer = window.setTimeout(() => {
          this.status.textContent = '';
          this.copyButton?.classList.remove('is-copied');
          this.copyButton?.setAttribute('aria-label', `Copy link to ${this.shareTitle}`);
        }, 3500);
      }
    }
  );
}
